import React, { useState, useEffect, useRef } from 'react';

// One 3D price scene (btc_3d_viewer.html); the frames are just camera angles on it:
//   2D  — flat left→right price chart + R indicator
//   VPO — the volume/time (TPO) profile face
// The scene opens on its own default angle (overview) — no frame is selected until the
// user clicks one, which postMessages the view and the scene flies its camera there.
const SCENE_SRC = '/btc_3d_viewer.html?v=27';
const FRAMES = [
  ['price', '2D'],
  ['vpo',   'VPO'],
];

const FRAME_STYLE = {
  position: 'absolute', inset: 0, width: '100%', height: '100%',
  border: 'none', background: '#05050f', display: 'block',
};

export default function OrderBook3D({ style }) {
  const [frame, setFrame] = useState(null);   // null = the scene's default opening angle
  const sceneRef = useRef(null);

  const sendView = (view) => {
    const w = sceneRef.current && sceneRef.current.contentWindow;
    if (w && view) w.postMessage({ type: 'xyr-view', view }, window.location.origin);
  };
  useEffect(() => { sendView(frame); }, [frame]);   // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', ...style }}>
      <iframe
        ref={sceneRef}
        src={SCENE_SRC}
        title="BTC 3D Price"
        style={FRAME_STYLE}
      />

      <div className="btc3d-screens" role="tablist" aria-label="BTC 3D frame">
        {FRAMES.map(([id, label]) => (
          <button
            key={id}
            role="tab"
            aria-selected={frame === id}
            className={frame === id ? 'on' : ''}
            onClick={() => setFrame(id)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
